import { RouterModule, Routes } from '@angular/router';
import { PageForbiddenComponent, PageNotFoundComponent } from '@elotech/angular-common';

export const routes: Routes = [
  {
    path: '', redirectTo: '/home', pathMatch: 'full'
  },
  {
    path: 'holerite',
    loadChildren: () => import('./holerite-detail/holerite-detail.module').then(m => m.HoleriteDetailModule)
  },
  {
    path: 'movimentacao-pessoal',
    loadChildren: () => import('./movimentacao-pessoal-view/movimentacao-pessoal-view.module').then(m => m.MovimentacaoPessoalViewModule)
  },
  {
    path: 'ferias',
    loadChildren: () => import('./ferias-detail/ferias-detail.module').then(m => m.FeriasDetailModule)
  },
  {
    path: 'licenca-premio',
    loadChildren: () => import('./licenca-premio-detail/licenca-premio-detail.module').then(m => m.LicencaPremioDetailModule)
  },
  {
    path: 'avaliacoes',
    loadChildren: () => import('./avaliacao/avaliacao-portal-servidor.module').then(m => m.AvaliacaoPortalServidorModule)
  },
  {
    path: 'comunicado-acidente-trabalho',
    loadChildren: () => import('./comunicado-acidente-trabalho/comunicado-acidente-trabalho.module').then(m => m.ComunicadoAcidenteTrabalhoModule)
  },
  {
    path: 'consulta-contribuicao-previdenciaria',
    loadChildren: () => import('./consulta-contribuicao-previdenciaria/consulta-contribuicao-previdenciaria.module').then(m => m.ConsultaContribuicaoPrevidenciariaModule)
  },
  {
    path: 'relatorios',
    loadChildren: () => import('./relatorios/relatorios.module').then(m => m.RelatoriosModule)
  },
  {
    path: 'turmas-disponiveis',
    loadChildren: () => import('./turmas-disponiveis/turmas-disponiveis.module').then(m => m.TurmasDisponiveisModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'forbidden', component: PageForbiddenComponent
  },
  {
    path: '**', component: PageNotFoundComponent
  }
];

export const routing = RouterModule.forRoot(routes, {});
